import React from 'react';
import {Redirect} from 'react-router-dom';
import LandingComponent from './auth/redirect';
import {createRoutes} from '../@e74/utility/Utils';
import {adminPagesConfigs} from './admin';
import {patientsPagesConfigs} from './patients';
import {reportsPagesConfigs} from './reports';
import {errorPagesConfigs} from './errorPages';
import {authRouteConfig} from './auth';
import {initialUrl} from '../shared/constants/AppConst';
import {usersPagesConfigs} from './users';
import {instancesPagesConfigs} from './instances';
import {resourcePagesConfigs} from './resources';
import {userMessagesPagesConfig} from './user-messages';
import {demoPagesConfigs} from './demo';
import {customFormsPagesConfigs} from './customforms';
import {clinicsPagesConfigs} from './clinics';
import {codePullPagesConfigs} from './codePulls';
import {auditPagesConfigs} from './audit';
import {foundryPagesConfigs} from './foundry';
import {foundryAgentPagesConfigs} from './foundryAgent';

const routeConfigs = [
  ...adminPagesConfigs,
  ...patientsPagesConfigs,
  ...usersPagesConfigs,
  ...instancesPagesConfigs,
  ...reportsPagesConfigs,
  ...errorPagesConfigs,
  ...authRouteConfig,
  ...resourcePagesConfigs,
  ...userMessagesPagesConfig,
  ...demoPagesConfigs,
  ...customFormsPagesConfigs,
  ...clinicsPagesConfigs,
  ...codePullPagesConfigs,
  ...auditPagesConfigs,
  ...foundryPagesConfigs,
  ...foundryAgentPagesConfigs,
];

const routes = [
  ...createRoutes(routeConfigs),
  {
    path: '/',
    exact: true,
    component: () => <LandingComponent/>,
  },
  {
    component: () => <Redirect to='/error-pages/error-404' />,
  },
];

export default routes;
